export class NewInvoiceUtil {

  static toHtml(x, club) {
    return `
        <style>
          body {
            width: 1000px;
          }
          .invoice-container {
            font-family: "Source Sans Pro", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
            padding: 20px;
            margin: auto;
            max-width: 800px;
          }
          .text-center {
            text-align: center;
          }
          .text-right {
            text-align: right;
          }
          .text-left {
            text-align: left;
          }
          .invoice-container h1 {
            margin: 30px 0 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid #ddd;
          }
          .invoice-container p {
            margin: 0;
            line-height: 2;
          }
          .h2 {
            font-size: 30px;
            margin-top: 20px;
          }
          .invoice-container table {
            width: 100%;
          }
          .invoice-container .table-bordered {
            margin-bottom: 20px;
            border: 1px solid #ddd;
            border-collapse: collapse;
          }
          .invoice-container .table-bordered tr td,
          .invoice-container .table-bordered tr th {
            border: 1px solid #ddd;
            padding: 8px;
            line-height: 1.42857143;
          }
          .invoice-container address {
            margin-bottom: 20px;
            font-style: normal;
            line-height: 1.42857143;
            font-size: 16px;
          }
          .invoice-container table tr td {
            vertical-align: baseline;
          }
        .modal-dialog.modal-dialog-middle {
           width: 900px;
           height: 750px !important;
        }
        .border-top {
            border-top: 1px solid #ebebeb!important;
        }
        py-3 {
            padding-bottom: 1rem!important;
        }
        .my-3 {
            margin-bottom: 1rem!important;
        }
        </style>
        <div class="invoice-container">
          <!--<div>#RECIEPT</div>-->
          <div class="col-md-6"><img class="tm-logo" src="/assets/img/tgs-logo-v1.png" /></div>
          <div class="col-md-6 font-w600 text-right">Transaction ID : ${x.invoice.transactionID}</div>
          <table class="invoice-table">
            <tr>
              <td>
                <p class="h2 font-w400 push-5">Total Global Sport</p>
                <address>
                202 Fashion Lane #101<br>
                Tustin, CA 92780<br>
                <i class="si si-call-end"></i><span></span> <span>1-855-847-1805</span>
                </address>
              </td>
              <td class="text-right">
                <p class="h2 font-w400 push-5">${club.name}</p>
                <address>
                ${club.address}<br>
                ${club.city}<br>
                ${club.statecode}, ${club.zip}<br>
                </address>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <table class="table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 50px;">TEAM ID</th>
                      <th class="text-left">PLAYER INFORMATION</th>
                      <th class="text-center" style="width: 80px;">DATE PAID</th>
                      <th class="text-left" style="width: 140px;">LEAGUE</th>
                      <th class="text-right" style="width: 120px;">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                  ` + x.details.map((d, idx) => `
                      <tr>
                        <td class="text-center">${d.teamID ? d.teamID : ''} </td>
                        <td>
                            <h2 style="font-size: 15px; margin-top: 0px;">
                            ${d.fullName}
                            </h2>
                            <div class="description">${d.userID}</div>
                        </td>
                        <td class="text-right">${d.paymentDate ? new Date(d.paymentDate).toLocaleDateString() : ''}</td>
                        <td class="text-right">${d.eventName ? d.eventName : ''}</td>
                        <td class="text-right">$${(d.amount || 0).toFixed(2)}</td>
                      </tr>`
    ).join('\n') + `
                       <tr>
                        <td colspan="4" class="font-w600 text-right">Credit Card</td>
                        <td class="text-right">${x.details[0].cardType} - ${x.details[0].maskedcardnum}
                        </td>
                      </tr>
                      <!--<tr>
                        <td colspan="4" class="font-w600 text-right">Transaction ID</td>
                        <td class="text-right">${x.invoice.transactionID}</td>
                      </tr>-->
                      <tr>
                        <td colspan="4" class="font-w700 text-right bg-body-light">Amount Paid</td>
                        <td class="text-right">$${(x.invoice.amount - (x.invoice.discount_amount || 0)).toFixed(2)}</td>
                      </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </table>
          <div class="col-md-12 text-center font-w600">
					  <div class="font-size-sm" style="padding-bottom: 30px;">
						  Thank You! We look forward to seeing you on the field. </div>
				  </div>
          <div style="padding-top: 35px;">
              <p class="font-size-sm text-muted text-center py-3 my-3 border-top" style="/* padding-bottom: 10px; */">
                Powered By: Total Global Sports • Simplify • Organize • Streamline
              </p>
          </div>
        </div>
      `;
  }

  static toHtmlNew(x, club) {
    return `
    <style>
        body {
            margin: 0;
            padding: 0;
            font-family: 'Arial';
        }

        div.page {
            background: #ffffff;
            /*position: relative;*/
            width: 8.5in;
            /*height: 11in;*/
            margin: 0.1cm auto;
        }

        @media print {
            div.page {
                margin: 0;
                page-break-after: always;
                border: none;
            }
        }

        .pagecontent {
            padding: .25cm;
        }

        .divFooter {
            /*position: absolute;*/
            /*bottom: 0.5cm;*/
            font-size: 10pt;
            /*left: 1.25cm;*/
            text-align: center;
            /*width: 19cm;*/
            border-top: 1px solid black;
            padding-top: 0.5cm;
        }

        table {
            width: 100%;
            border-collapse: collapse;
        }

        td {
            padding: 0;
            margin: 0;
            border-collapse: collapse;
        }

        .tblDetails td {
            border: 1px solid #69696b;
            border-bottom: 1px dotted grey;
            padding-top: 10px;
            padding-bottom: 10px;
            padding-left: 4px;
        }

        .tblDetails tr:first-child td {
            padding: 3px;
            font-weight: bold;
            border: none;
            height: 19px;
        }

        .tblCategory td {
            height: 29px;
            border-bottom: 1px dotted black;
        }

        .tblCategory2 {
            border: 1px solid black;
        }

        .tblCategory2 td {
            height: 19px;
        }

        p {
            margin: 0;
            padding: 0;
        }

        .txt20 {
            font-size: 20pt;
            font-weight: bold;
        }

        .txt18 {
            font-size: 18pt !important;
            font-weight: bold !important;
        }

        .block-content p {
          margin-bottom: 0px !important;
        }

        .txt15 {
            font-size: 15pt;
            font-weight: bold;
        }

        .txt14 {
            font-size: 14pt;
        }

        .txt12 {
            font-size: 12pt;
        }

        .txt10 {
            font-size: 10pt;
        }

        .txt9 {
            font-size: 9pt;
        }

        .txt8 {
            font-size: 8pt;
            font-style: italic;
            color: #696a6c;
        }

        .txtCenter {
            text-align: center;
        }

        .txtRight {
            text-align: right;
        }

        .txtBold {
            font-weight: bold;
        }

        .txtGray {
            color: #696a6c;
        }

        .txtBlue {
            color: #5e90cb;
        }

        img {
            width: 100%;
        }

        .bgGray {
            background: #f4f5f6;
            padding: 6px 8px;
        }

        .btb {
            border-top: 1px solid black !important;
            border-bottom: 1px solid black !important;
        }

        .nb {
            border: none !important;
            border-bottom: 1px dotted grey !important;
        }
    </style>
</head>
<body>
<div class="page">
    <div class="pagecontent">
        <table style="margin-top: 18px;">
            <tbody><tr>
                <td width="15%" valign="top">
                    <img src="https://s3.amazonaws.com/images.totalglobalsports.com/tgs_invoice_Logo.png" alt="Image">
                </td>
                <td width="45%" valign="top"></td>
                <td width="40%" valign="top" style="padding-top: 2px;">
                    <p class="txt10 txtBold txtRight" style="margin-top: 5px;">Transaction ID: ${x.invoice.transactionID}</p>
                </td>
            </tr>
        </tbody></table>

        <table style="margin-top: 5px;">
            <tbody><tr>
                <td width="50%" style="height: 43px; padding-left: 1px;">
                    <p class="txt18">Total Global Sports</p>
                </td>
                <td width="50%">
                    <p class="txt18 txtRight">${club.name}</p>
                </td>
            </tr>
            <tr>
                <td style="padding-top: 5px;" valign="top">
                    <p class="txt12">202 Fashion Lane #101 <br>
                        Tustin, CA 92780<br>
                        1-855-847-1805</p>
                </td>
                <td style="padding-top: 5px;" valign="top">
                    <p class="txt12 txtRight">
                    ${club.address}<br>
                    ${club.city}<br>
                    ${club.statecode}, ${club.zip}
                    </p>
                </td>
            </tr>
        </tbody></table>

        <table class="tblDetails" style="margin-top: 45px;">
            <tbody><tr>
                <td width="12%" class="btb" style="border-left: 1px solid black;"><p class="txt10 txtBold">TEAM ID</p></td>
                <td width="28%" class="btb"><p class="txt10 txtBold">PLAYER INFORMATION</p></td>
                <td width="15%" class="btb"><p class="txt10 txtBold">DATE PAID</p></td>
                <td width="30%" class="btb"><p class="txt10 txtBold">LEAGUE</p></td>
                <td width="15%" class="btb" style="border-right: 1px solid black;"><p class="txt10 txtBold txtRight">AMOUNT</p></td>
            </tr>
            ` + x.details.map((d, idx) => `
            <tr>
                <td class="nb" valign="top"><p class="txt9">${d.teamID ? d.teamID : ''}</p></td>
                <td class="nb" valign="top"><p class="txt9"><b>${d.fullName}</b><br>${d.userID}</p></td>
                <td class="nb" valign="top"><p class="txt9">${d.paymentDate ? new Date(d.paymentDate).toLocaleDateString() : ''}</p></td>
                <td class="nb" valign="top"><p class="txt9">${d.eventName ? d.eventName : ''}</p></td>
                <td class="nb" valign="top"><p class="txt9 txtRight">$${(d.amount || 0).toFixed(2)}</p></td>
            </tr>
            `).join('\n') + `
        </tbody></table>
        <table style="margin-top: 15px;">
            <tbody><tr>
                <td width="85%" valign="top"><p class="txt10 txtRight"><b>Credit Card</b></p></td>
                <td width="15%" valign="top"><p class="txt10 txtRight">${x.details[0].cardType}-${x.details[0].maskedcardnum}</p></td>
            </tr>
            <tr>
                <td valign="top" style="padding-top: 10px;"><p class="txt10 txtRight"><b>Amount Paid</b></p></td>
                <td valign="top" style="padding-top: 10px;"><p class="txt10 txtRight">$${(x.invoice.amount - (x.invoice.discount_amount || 0)).toFixed(2)}</p></td>
            </tr>
        </tbody></table>

        <div class="divFooter">
            Powered By Total Global Sports • Simplify • Organize • Streamline
        </div>
    </div>
</div>
    `;
  }

  static toEventPlayerCheckingPaymentHtml(x, club) {
    return `
    <style>
        body {
            margin: 0;
            padding: 0;
            font-family: 'Arial';
        }

        div.page {
            background: #ffffff;
            /*position: relative;*/
            width: 8.5in;
            /*height: 11in;*/
            margin: 0.1cm auto;
        }

        @media print {
            div.page {
                margin: 0;
                page-break-after: always;
                border: none;
            }
        }

        .pagecontent {
            padding: .25cm;
        }

        .divFooter {
            /*position: absolute;*/
            /*bottom: 0.5cm;*/
            font-size: 10pt;
            /*left: 1.25cm;*/
            text-align: center;
            /*width: 19cm;*/
            border-top: 1px solid black;
            padding-top: 0.5cm;
        }

        table {
            width: 100%;
            border-collapse: collapse;
        }

        td {
            padding: 0;
            margin: 0;
            border-collapse: collapse;
        }

        .tblDetails td {
            border: 1px solid #69696b;
            border-bottom: 1px dotted grey;
            padding-top: 10px;
            padding-bottom: 10px;
            padding-left: 4px;
        }

        .tblDetails tr:first-child td {
            padding: 3px;
            font-weight: bold;
            border: none;
            height: 19px;
        }

        .tblCategory td {
            height: 29px;
            border-bottom: 1px dotted black;
        }

        .tblCategory2 {
            border: 1px solid black;
        }

        .tblCategory2 td {
            height: 19px;
        }

        p {
            margin: 0;
            padding: 0;
        }

        .txt20 {
            font-size: 20pt;
            font-weight: bold;
        }

        .txt18 {
            font-size: 18pt !important;
            font-weight: bold !important;
        }

        .block-content p {
          margin-bottom: 0px !important;
        }

        .txt15 {
            font-size: 15pt;
            font-weight: bold;
        }

        .txt14 {
            font-size: 14pt;
        }

        .txt12 {
            font-size: 12pt;
        }

        .txt10 {
            font-size: 10pt;
        }

        .txt9 {
            font-size: 9pt;
        }

        .txt8 {
            font-size: 8pt;
            font-style: italic;
            color: #696a6c;
        }

        .txtCenter {
            text-align: center;
        }

        .txtRight {
            text-align: right;
        }

        .txtBold {
            font-weight: bold;
        }

        .txtGray {
            color: #696a6c;
        }

        .txtBlue {
            color: #5e90cb;
        }

        img {
            width: 100%;
        }

        .bgGray {
            background: #f4f5f6;
            padding: 6px 8px;
        }

        .btb {
            border-top: 1px solid black !important;
            border-bottom: 1px solid black !important;
        }

        .nb {
            border: none !important;
            border-bottom: 1px dotted grey !important;
        }
    </style>
</head>
<body>
<div class="page">
    <div class="pagecontent">
        <table style="margin-top: 18px;">
            <tbody><tr>
                <td width="15%" valign="top">
                    <img src="https://s3.amazonaws.com/images.totalglobalsports.com/tgs_invoice_Logo.png" alt="Image">
                </td>
                <td width="45%" valign="top"></td>
                <td width="40%" valign="top" style="padding-top: 2px;">
                    <p class="txt10 txtBold txtRight" style="margin-top: 5px;">Transaction ID: ${x.invoice.transactionID}</p>
                </td>
            </tr>
        </tbody></table>

        <table style="margin-top: 5px;">
            <tbody><tr>
                <td width="50%" style="height: 43px; padding-left: 1px;">
                    <p class="txt18">Total Global Sports</p>
                </td>
                <td width="50%">
                    <p class="txt18 txtRight">${club.name}</p>
                </td>
            </tr>
            <tr>
                <td style="padding-top: 5px;" valign="top">
                    <p class="txt12">202 Fashion Lane #101 <br>
                        Tustin, CA 92780<br>
                        1-855-847-1805</p>
                </td>
                <td style="padding-top: 5px;" valign="top">
                    <p class="txt12 txtRight">
                    ${club.address}<br>
                    ${club.city}<br>
                    ${club.statecode}, ${club.zip}
                    </p>
                </td>
            </tr>
        </tbody></table>

        <table class="tblDetails" style="margin-top: 45px;">
            <tbody><tr>
                <td width="12%" class="btb" style="border-left: 1px solid black;"><p class="txt10 txtBold">TEAM ID</p></td>
                <td width="28%" class="btb"><p class="txt10 txtBold">PLAYER INFORMATION</p></td>
                <td width="15%" class="btb"><p class="txt10 txtBold">DATE PAID</p></td>
                <td width="30%" class="btb"><p class="txt10 txtBold">LEAGUE</p></td>
                <td width="15%" class="btb" style="border-right: 1px solid black;"><p class="txt10 txtBold txtRight">AMOUNT</p></td>
            </tr>
            ` + x.details.map((d, idx) => `
            <tr>
                <td class="nb" valign="top"><p class="txt9">${d.teamID ? d.teamID : ''}</p></td>
                <td class="nb" valign="top"><p class="txt9"><b>${d.fullName}</b><br>${d.userID}</p></td>
                <td class="nb" valign="top"><p class="txt9">${d.paymentDate ? new Date(d.paymentDate).toLocaleDateString() : ''}</p></td>
                <td class="nb" valign="top"><p class="txt9">${d.eventName ? d.eventName : ''}</p></td>
                <td class="nb" valign="top"><p class="txt9 txtRight">$${(d.amount || 0).toFixed(2)}</p></td>
            </tr>
            `).join('\n') + `
        </tbody></table>
        <table style="margin-top: 15px;">
            <tbody><tr>
                <td width="85%" valign="top"><p class="txt10 txtRight"><b>Total</b></p></td>
                <td width="15%" valign="top"><p class="txt10 txtRight">$${(x.invoice.amount - (x.invoice.discount_amount || 0)).toFixed(2)}</p></td>
            </tr>
            <tr>
                <td valign="top" style="padding-top: 10px;"><p class="txt10 txtRight"><b>Transaction Fee</b></p></td>
                <td valign="top" style="padding-top: 10px;"><p class="txt10 txtRight">$${(x.invoice.processingFee || 0).toFixed(2)}</p></td>
            </tr>
            <tr>
                <td valign="top" style="padding-top: 10px;"><p class="txt10 txtRight"><b>Amount Paid</b></p></td>
                <td valign="top" style="padding-top: 10px;"><p class="txt10 txtRight">$${((x.invoice.amount + x.invoice.processingFee || 0) - (x.invoice.discount_amount || 0)).toFixed(2)}</p></td>
            </tr>
            <tr>
                <td valign="top" style="padding-top: 10px;"><p class="txt10 txtRight"><b>Paid With</b></p></td>
                <td valign="top" style="padding-top: 10px;"><p class="txt10 txtRight">${x.details[0].cardType}-${x.details[0].maskedcardnum}</p></td>
            </tr>
        </tbody></table>

        <div class="divFooter">
            Powered By Total Global Sports • Simplify • Organize • Streamline
        </div>
    </div>
</div>
    `;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/utils/newInvoice.util.ts